import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  postMatchReport,
  postProfileReport,
  type PostMatchReportParams,
  type PostProfileReportParams,
  type PostReportResponse,
} from '@services/ReportsService';

export type PostReportParams = PostProfileReportParams | PostMatchReportParams;

export type UsePostReportParams = {
  mutationOptions?: SWRMutationConfiguration<
    PostReportResponse,
    unknown,
    string,
    PostReportParams,
    PostReportResponse
  >;
};

export const postReportMutationKey = 'post-report';

const isMatchReportParams = (
  params: PostReportParams,
): params is PostMatchReportParams => {
  return 'matchId' in params;
};

export const usePostReport = ({
  mutationOptions,
}: UsePostReportParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PostReportResponse,
    unknown,
    string,
    PostReportParams
  >(
    postReportMutationKey,
    (_url, { arg }) =>
      isMatchReportParams(arg) ? postMatchReport(arg) : postProfileReport(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
